import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TimeSlotHeatmapView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  className: 'processing item w2 h2'

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.time_slot_heat_map')
    @title_en = I18n.t('monitoring.dashboard.charts.time_slot_heat_map', {'locale': 'en'})
    @searchQuery = @options.searchQuery
    @data = []
    @_settings = @options.settings
    @container = @options.container

  render: ->
    @$el.html(@template({
      title: @title
    }))
    return this

  afterAppend: ->
    @ajaxCall('/monitoring/api/charts/time_slots', @searchQuery.toJSON(), (response) =>
      @data = response
      @chart = new Highcharts.Chart(@chartOptions())
    )

  hours: ->
    "#{hour}:00" for hour in [0..23]

  weekdays: ->
    ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

  chartOptions: ->
    {
      chart:
        renderTo: @$el.find('.chart')[0]
        type: 'heatmap'
        marginTop: 40
        marginBottom: 40
      title:
        text: null
      xAxis:
        categories: @hours()
      yAxis:
        categories: @weekdays(),
        title: null
      colorAxis:
        min: 0
        minColor: '#FFFFFF'
        maxColor: Highcharts.getOptions().colors[0]
      legend:
        enabled: false
      tooltip:
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        formatter: ->
          @series.yAxis.categories[@point.y] + ', ' + @series.xAxis.categories[@point.x] + '<br>contents: ' + @point.value
      series: [{
        borderWidth: 0
        data: @data.data
        dataLabels:
          enabled: true
          color: 'black'
          style:
            textShadow: 'none'
            opacity: 0.4
      }]
      exporting:
        sourceWidth: @$el.find('.chart').width()
        sourceHeight: @$el.find('.chart').height()
        scale: 1
    }
